import * as React from 'react';
import './styles.sass';

interface IAccordionProps {
  title?: string;
  children: any;
}

const PREFIX = 'accordion';

export const Accordion: React.StatelessComponent<IAccordionProps> = ({title, children}) => (
  <div className={`${PREFIX}`}>
    {title &&
    <div className={`${PREFIX}__title`}>{title}</div>
    }
    {children}
  </div>
);
